<template>
  <b-modal
    id="ip-previewmodal"
    centered
    hide-footer
    hide-header
    :visible="ipmodal"
    no-close-on-backdrop
    @hidden="closeModal"
  >
    <div class="d-flex align-items-center justify-content-between m-3">
      <div class="teams-modal-head">Preview Feedback Form</div>
      <div @click="closeModal">
        <img
          src="../../assets/New-imgs/teams-icons/teams-close-icon.svg"
          alt=""
          class="pointer rotate-on-hover"
        />
      </div>
    </div>
    <hr class="mb-0" />
    <div class="p-3">
      <div
        class="newInt-preview-modalhead text-truncate"
        v-if="selectedRound.name"
      >
        {{ selectedRound.name | accesscontrolrolesdesc }}
      </div>
      <div class="newInt-preview-container pr-1">
        <div class="p-3">
          <div class="newInt-preview-container-head">Basic Info</div>

          <div class="mt-3 d-flex align-items-center">
            <div class="newInt-preview-inputHead" style="width: 40%">
              Candidate Name
            </div>

            <div style="width: 60%">
              <b-form-input
                class="newInt-preview-inputField w-100"
                v-model="basicCandInfo.name"
                disabled
              >
              </b-form-input>
            </div>
          </div>

          <div class="mt-3 d-flex align-items-center">
            <div class="newInt-preview-inputHead" style="width: 40%">
              Evaluation Date
            </div>

            <div style="width: 60%">
              <b-form-input
                class="newInt-preview-inputField w-100"
                v-model="basicCandInfo.evalDate"
                disabled
              >
              </b-form-input>
            </div>
          </div>

          <div class="mt-3 d-flex align-items-center">
            <div class="newInt-preview-inputHead" style="width: 40%">
              Panel Name
            </div>

            <div style="width: 60%">
              <b-form-input
                class="newInt-preview-inputField w-100"
                placeholder="-"
                v-model="basicCandInfo.panel"
                disabled
              >
              </b-form-input>
            </div>
          </div>
          <div class="mt-3 d-flex align-items-center">
            <div class="newInt-preview-inputHead" style="width: 40%">
              Mode Of Interview
            </div>

            <div style="width: 60%">
              <b-form-input
                class="newInt-preview-inputField w-100"
                v-model="basicCandInfo.modeOfInterview"
                disabled
              >
              </b-form-input>
            </div>
          </div>
          <div
            class="mt-3 d-flex align-items-center"
            v-if="basicCandInfo.action"
          >
            <div class="newInt-preview-inputHead" style="width: 40%">
              Action
            </div>

            <div style="width: 60%">
              <b-form-input
                class="newInt-preview-inputField w-100"
                v-model="candidateAction"
                disabled
              >
              </b-form-input>
            </div>
          </div>
          <div
            class="mt-3 d-flex align-items-center"
            v-if="basicCandInfo.action == 'NI' && basicCandInfo.remarks"
          >
            <div class="newInt-preview-inputHead" style="width: 40%">
              Remarks
            </div>

            <div style="width: 60%">
              <b-form-input
                class="newInt-preview-inputField w-100"
                v-model="basicCandInfo.remarks"
                disabled
              >
              </b-form-input>
            </div>
          </div>
        </div>
        <template
          v-if="
            basicCandInfo.modeOfInterview === 'assesment' &&
            basicCandInfo.feedback &&
            basicCandInfo.feedback.status === 2
          "
        >
          <div class="my-2 newJD-int-container p-0">
            <div class="newJD-int-container-selected pointer">
              <div class="newJD-int-mainhead">Assessment</div>
            </div>
            <div class="p-3">
              <div class="d-flex align-items-center justify-content-between">
                <div class="newCand-viewFdbck-font">
                  Total Marks :
                  {{ basicCandInfo.feedback.marks.marksScored }}/{{
                    basicCandInfo.feedback.marks.totalMarks
                  }}
                </div>
                <div class="newCand-viewFdbck-font">
                  Passing Percentage (%) :
                  {{
                    basicCandInfo.feedback.passingStatus.passingPercentage
                  }}/100
                </div>
              </div>

              <div
                class="
                  d-flex
                  align-items-center
                  justify-content-between
                  mt-2
                  w-100
                "
              >
                <div style="width: 90%">
                  <div class="newCand-viewFdbck-head">Sections</div>
                  <div
                    v-for="(section, index) in basicCandInfo.feedback.marks
                      .sectionMarks"
                    :key="index"
                    class="mt-2 newCand-viewFdbck-subhead"
                  >
                    {{ section.sectionName }}
                  </div>
                </div>
                <div style="width: 10%">
                  <div class="newCand-viewFdbck-head">Marks</div>
                  <div
                    v-for="(section, index) in basicCandInfo.feedback.marks
                      .sectionMarks"
                    :key="index"
                    class="mt-2 newCand-viewFdbck-font"
                  >
                    {{ section.sectionMarksScored }}/{{
                      section.sectionMarksTotal
                    }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
        <div v-if="selectedRound.skills && selectedRound.skills.length != 0">
          <div
            class="mt-3 newInt-inner-containers"
            v-for="(input, k) in selectedRound.skills"
            :key="k"
          >
            <div :style="input.name.length > 30 ? 'width: 70%' : ''">
              <div class="newInt-inner-containers-head mb-2 text-truncate">
                {{ input.name }} &nbsp;<span
                  v-if="input.mandatory == true"
                  class="asterik"
                  >*</span
                >
              </div>

              <div class="mt-2 d-flex" v-if="input.markingType == 'rating'">
                <div class="mt-2 newInt-inner-containers-subhead">Rating</div>
                <div>
                  <b-form-rating
                    variant="primary"
                    v-model="input.mark"
                    class="mb-2 newInt-rating p-0 w-25 ml-2"
                    disabled
                  ></b-form-rating>
                </div>
              </div>

              <div v-if="input.markingType == 'score'">
                <div class="topDiv d-flex align-items-center">
                  <div>
                    <label class="newInt-inner-containers-subhead">Score</label>
                  </div>
                  <div class="ml-2">
                    <b-form-input
                      class="newInt-previewInputField-score no-spinner"
                      v-model="input.mark"
                      disabled
                      type="number"
                    >
                    </b-form-input>
                  </div>
                  <div class="ml-2 newInt-preview-container-subFont">
                    Out of 10
                  </div>
                </div>
              </div>
              <div class="mt-2" v-if="input.commentMode == true">
                <div class="topDiv">
                  <div>
                    <label class="newInt-inner-containers-subhead"
                      >Comments</label
                    >
                  </div>
                  <div class="mt-1">
                    <b-form-textarea
                      class="newInt-previewInputField"
                      v-model="input.comments"
                      placeholder="Comments will be shown here"
                      disabled
                      rows="3"
                      max-rows="4"
                    >
                    </b-form-textarea>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          class="mt-3 newInt-inner-containers"
          v-if="showScreenshot && allData.candidateImage"
        >
          <div class="d-flex align-items-center">
            <div>
              <img
                src="../../assets/New-imgs/interviewProcess-icons/newInt-cand-screenshot.svg"
                alt=""
              />
            </div>
            <div class="newInt-sc-font ml-3">Candidate Screenshot</div>
          </div>

          <div
            class="
              mt-3
              newInt-previewNoImageInputField-sc
              d-flex
              align-items-center
              justify-content-center
            "
          >
            <div class="sc-font" v-if="allData.candidateImage">
              <img
                class="h-100 w-100"
                :src="allData.candidateImage"
                alt="Candidate Image"
              />
            </div>
          </div>
        </div>
        <div
          class="mt-3 newInt-inner-containers"
          v-else-if="
            ($route.name == 'CreateInterviewProcess' ||
              $route.name == 'EditInterviewProcess' ||
              $route.name == 'ActivateInterview' ||
              $route.name == 'Feedbackform') &&
            selectedRound.screenshot
          "
        >
          <div class="mt-3 newInt-inner-containers ml-1 mr-1">
            <div class="d-flex align-items-center">
              <div>
                <img
                  src="../../assets/New-imgs/interviewProcess-icons/newInt-cand-screenshot.svg"
                  alt=""
                />
              </div>
              <div class="newInt-sc-font ml-3">Candidate Screenshot</div>
            </div>

            <div
              class="
                mt-3
                newInt-previewInputField-sc
                d-flex
                align-items-center
                justify-content-center
              "
            >
              <div class="sc-font" v-if="selectedRound.screenshot">
                Screenshot will be shown here
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </b-modal>
</template>
<script>
import interviewProcessMixins from "./interviewProcessMixins";

export default {
  name: "PreviewFeedbackStatic",
  mixins: [interviewProcessMixins],
  props: {
    selectedRound: Object,
    basicCandInfo: Object,
    allData: Object,
    ipmodal: Boolean,
    showScreenshot: Boolean,
  },
  computed: {
    candidateAction() {
      if (
        this.basicCandInfo.action == "S" ||
        this.basicCandInfo.action == "F"
      ) {
        return "Selected";
      } else if (this.basicCandInfo.action == "R") {
        return "Rejected";
      } else if (this.basicCandInfo.action == "NI") {
        return "Not Interested";
      } else if (this.basicCandInfo.action == "H") {
        return "On Hold";
      }
      return "";
    },
    // modeOfInteriew() {
    //   return this.basicCandInfo.modeOfInterview == "f2f"
    //     ? "Face to Face"
    //     : "Assessment";
    // },
  },
  methods: {
    closeModal() {
      this.$emit("closeModal");
    },
  },
};
</script>
